import React from "react";
import { Button } from "reactstrap";
import { authUser } from "../requests/req_auth";
import { notifica, show_ldr } from "../requests/utils";

export default class Login extends React.Component {
  constructor(props) {
    super(props);
    this.key = this.key.bind(this);
    this.valida = this.valida.bind(this);
  }

  valida(e) {
    if (
      document.getElementById("inp_us").value === "" ||
      document.getElementById("inp_ps").value === ""
    ) {
      notifica("warning", "Debes capturar usuario y contraseña", "Alerta!");
    } else {
      show_ldr(true);
      authUser();
    }
  }

  //Función para validar datos al presionar Enter
  key(e) {
    var ev = e.key,
      pr = e.target,
      ps = pr.value,
      us = document.getElementById("inp_us").value;
    if (us !== "" && ps !== "" && ev === "Enter") {
      this.valida();
    }
  }

  render() {
    return (
      <div className="login-box">
        <img
          src={`${process.env.PUBLIC_URL}/images/logo_1.jpg`}
          class="avatar"
          alt="Avatar Image"
        />

        <h1>Iniciar Sesión</h1>
        <br />
        <label for="username">Usuario</label>
        <input type="text" placeholder="Ingresa tu Usuario" id="inp_us" />
        <label for="password">Contraseña </label>
        <input
          type="password"
          placeholder="Ingresa tu Contraseña"
          id="inp_ps"
        />
        <Button
          color="secondary"
          onClick={(e) => this.valida(e)}
          className={"btn_login"}
        >
          Validar
        </Button>
        <a href="#">Olvidaste tu contraseña?</a>
      </div>
    );
  }
}
